import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetBidsQueryResponse, GetBidsQueryParams, GetBids400, GetBids401, GetBids403, GetBids422, GetBids429, GetBids500 } from "../types/GetBids";

export const getBidsQueryKey = (params: GetBidsQueryParams) =>     [{url:`/api/purchase-tenders/v1/bids`},...(params ? [params] : [])] as const;
      export function getBidsQueryOptions <TData = GetBidsQueryResponse, TError = GetBids400 | GetBids401 | GetBids403 | GetBids422 | GetBids429 | GetBids500>(params: GetBidsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getBidsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v1/bids`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v1/bids
 */

export function useGetBids <TData = GetBidsQueryResponse, TError = GetBids400 | GetBids401 | GetBids403 | GetBids422 | GetBids429 | GetBids500>(params: GetBidsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getBidsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getBidsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
